var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 93,
    viewBox: "0 0 94 93",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M66.3754 81.375L85.75 62M85.7496 81.375L66.375 62",
    stroke: "#8E9297",
    strokeWidth: 3.875
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.0625 54.25V48.4375C76.0625 41.1307 76.0625 37.4773 73.7926 35.2074C71.5227 32.9375 67.8693 32.9375 60.5625 32.9375H55.3578C52.19 32.9375 50.6061 32.9375 49.1819 32.3476C47.7576 31.7576 46.6376 30.6376 44.3977 28.3977L41.8523 25.8523C39.6124 23.6124 38.4924 22.4924 37.0681 21.9024C35.6439 21.3125 34.06 21.3125 30.8922 21.3125H29.5625C22.2557 21.3125 18.6023 21.3125 16.3324 23.5824C14.0625 25.8523 14.0625 29.5057 14.0625 36.8125V56.1875C14.0625 63.4943 14.0625 67.1477 16.3324 69.4176C18.6023 71.6875 22.2557 71.6875 29.5625 71.6875H58.625",
    stroke: "#8E9297",
    strokeWidth: 3.875
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/EmptyFolder.c957650a51307a4cb5463c6f2068b412.svg";
export { ForwardRef as ReactComponent };